import CallApi from './CallApi';

/**
 * L+ Suite = caisse en version 2.x ou plus. La règle vit côté serveur (la version est dans la base
 * du client), le front se contente de la demander — il la déduisait auparavant du groupe
 * `laddition-suite` de l'utilisateur, ce qui pouvait diverger de ce que le back considère comme Suite.
 *
 * La réponse est mémorisée pour la session : plusieurs écrans la demandent, l'appel n'est fait
 * qu'une fois. Un changement d'utilisateur passe par un rechargement de l'application.
 */
let pending = null;

const isSuiteAccount = () => {
	if (!pending) {
		pending = CallApi('GET', 'customer-account/isSuite', '', {})
			.then(res => !!(res && res[0] && res[0].isSuite))
			.catch(() => false);
	}
	return pending;
};

export default isSuiteAccount;
